import { useMemo, type ReactNode } from "react";

import { BrandTuckInsContext } from "@/components/brand-tuck-ins";
import { useBrands } from "@/hooks/use-brands";

/** Feeds the brand picker its tuck-ins from the cached registry list. */
export function BrandTuckInsProvider({ children }: { children: ReactNode }) {
  const { data: brands } = useBrands();
  const tuckIns = useMemo(() => (brands ?? []).filter((b) => b.consolidated && b.parent_id !== null), [brands]);
  return <BrandTuckInsContext.Provider value={tuckIns}>{children}</BrandTuckInsContext.Provider>;
}
